import {action, makeAutoObservable} from 'mobx'
import {SetUtil} from 'yougile-util'
import {DataObjectId} from 'yougile-model'
import {Sync} from '@client/sync'
import {SyncEvents} from '@client/sync-events'
import {createUseStore} from '@containers/hooks'
import {SubtaskUtil} from '@extensions/subtask-util'

interface State {
  opened: Set<DataObjectId>
  parentTaskIds: DataObjectId[]
}

export class ParentTasksStore {
  state: State = {
    opened: new Set(),
    parentTaskIds: []
  }
  private syncListenerId?: number

  constructor(
    public taskId: DataObjectId,
    public onBoard: boolean
  ) {
    makeAutoObservable(this, {
      dispose: action.bound,
      updateParentTaskIds: action.bound
    })

    const companyId = Sync.getCurrentSandbox().companyId
    this.syncListenerId = SyncEvents.addListener(
      companyId,
      '*',
      this.updateParentTaskIds
    )
    this.updateParentTaskIds()

    if (onBoard) {
      this.state.parentTaskIds.forEach(id => this.toggleOpen(id))
    }
  }

  updateParentTaskIds(): void {
    this.state.parentTaskIds = [...SubtaskUtil.getParentTaskIds(this.taskId)]
  }

  toggleOpen(taskId: DataObjectId): void {
    SetUtil.toggle(this.state.opened, taskId)
  }

  dispose(): void {
    if (this.syncListenerId) {
      SyncEvents.removeListener(this.syncListenerId)
      this.syncListenerId = undefined
    }
  }
}

const [StoreContext, useStore] = createUseStore(ParentTasksStore)
export {StoreContext, useStore}
